import { useEffect, useMemo, useState } from "react";

export const V2_ROUTES = {
  home: "home",
  addKnowledge: "add-knowledge",
  insightsInbox: "insights-inbox",
  baselineApprovals: "baseline-approvals",
  architectureGallery: "architecture-gallery",
  reports: "reports",
  explorer: "explorer",
  admin: "admin",
  help: "help",
  settings: "settings",
};

/** Sidebar / primary nav order (explorer is reachable via deeplink / Your Map, not a sidebar tab). */
export const V2_ROUTE_ORDER = [
  V2_ROUTES.home,
  V2_ROUTES.addKnowledge,
  V2_ROUTES.insightsInbox,
  V2_ROUTES.baselineApprovals,
  V2_ROUTES.architectureGallery,
  V2_ROUTES.reports,
  V2_ROUTES.admin,
  V2_ROUTES.help,
  V2_ROUTES.settings,
];

const ALL_V2_ROUTES = new Set(Object.values(V2_ROUTES));

export function useV2Navigation(
  initialRoute = V2_ROUTES.home,
  routeOrder = V2_ROUTE_ORDER
) {
  const order = useMemo(
    () => (Array.isArray(routeOrder) && routeOrder.length ? routeOrder : V2_ROUTE_ORDER),
    [routeOrder]
  );
  // Allow routes like explorer that are valid app screens but not sidebar tabs.
  const normalizedInitial = ALL_V2_ROUTES.has(initialRoute)
    ? initialRoute
    : order[0] || V2_ROUTES.home;
  const [route, setRoute] = useState(normalizedInitial);

  useEffect(() => {
    if (!ALL_V2_ROUTES.has(route)) {
      setRoute(order[0] || V2_ROUTES.home);
    }
  }, [order, route]);

  return {
    route,
    routes: order,
    navigate: setRoute,
  };
}
